import { createContext, useContext, useMemo, useState } from 'react';
import { TicketCreation } from '../containers/TicketCreation';
import { usePortalData } from '../data/usePortalData';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TicketCreationContext = /*#__PURE__*/createContext(undefined);
export function useTicketCreation() {
  const ctx = useContext(TicketCreationContext);
  if (!ctx) {
    throw new Error('useTicketCreation must be used within TicketCreationProvider');
  }
  return ctx;
}
export function TicketCreationProvider({
  children
}) {
  var _data$settings$formHe, _data$settings;
  const [open, setOpen] = useState(false);
  const {
    data
  } = usePortalData();
  const title = (_data$settings$formHe = data === null || data === void 0 || (_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : _data$settings.formHeaderText) !== null && _data$settings$formHe !== void 0 ? _data$settings$formHe : '';
  const value = useMemo(() => ({
    isOpen: open,
    open: () => setOpen(true),
    close: () => setOpen(false)
  }), [open]);
  return /*#__PURE__*/_jsxs(TicketCreationContext.Provider, {
    value: value,
    children: [children, open && /*#__PURE__*/_jsxs(Panel, {
      maxInlineSize: "100dvw",
      width: 560,
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: value.close,
        "aria-label": I18n.text('customer-portal-app.ticketCreationProvider.ticketCreationCloseButton')
      }), /*#__PURE__*/_jsx(PanelHeader, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          children: title
        })
      }), /*#__PURE__*/_jsx(PanelSection, {
        padding: "0",
        flush: true,
        children: /*#__PURE__*/_jsx(TicketCreation, {})
      })]
    })]
  });
}